"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'Checkbox can be checked as its initial state.';
var code = "import React from 'react';\nimport { Checkbox } from 'jsc-react-ui';\n\nconst CheckboxExample = () => <Checkbox checked>Cinema</Checkbox>;";
exports.CheckedExampleCheckbox = function () { return (React.createElement(common_1.Example, { title: "Checked", description: description, code: code },
    React.createElement(components_1.Checkbox, { checked: true }, "Cinema"))); };
exports.CheckedExampleCheckbox.displayName = 'CheckedExampleCheckbox';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCheckboxPage/CheckedExampleCheckbox.tsx
// module id = 650
// module chunks = 0